import React, { Component } from "react";
import { Row, Col, Container, Card } from "react-bootstrap";

import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import compose from "lodash.flowright";
import CreateAdaptiveExams from "./CreateAdaptiveExams";
import { isBrowser } from "react-device-detect";
import { graphql, withApollo } from "react-apollo";
import gql from "graphql-tag";
import PreloaderTwo from '../preloader/PreloaderTwo';
import DataTableWithOutSearch from "../datatables/DataTableWithOutSearch";

const FETCH_GLOBALS = gql`
  query ($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects {
          subject_id
        }
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects {
        id
        subject
      }
      offlineFeeTypes {
        id
        fee_type
      }
    }
  }
`;

// const FETCH_EXAMS = gql`
//   query GetAdaptiveQuestions($institution_id: Int!, $exam_paper_id: Int, $type: String) {
//     getAdaptiveQuestions(
//       institution_id: $institution_id
//       exam_paper_id: $exam_paper_id
//       type: $type
//     ) {
//       id
//       exam_mode
//       name
//       exam_type
//       start_time
//       end_time
//       is_completed
//       filename
//       exam_name
//       class
//       class_id
//       sub_exam_type
//       section
//       branch
//     }
//     manageQuestions(
//       institution_id: $institution_id,
//       exam_paper_id: $exam_paper_id
//     ) {
//       id
//       exam_mode
//       name
//       exam_type
//       no_of_sets
//       start_time
//       end_time
//       is_completed
//       filename
//       exam_name
//       class
//       class_id
//       sub_exam_type
//       section
//       branch
//     }
//   }
// `;

const DELETE_EXAM = gql`
  mutation(
    $exam_paper_id: ID
    ) {
        deleteExamPaper(
            exam_paper_id: $exam_paper_id
    )
  }
`;

const CREATE_ADAPTIVE_EXAM = gql`
  mutation CreateAdaptiveExam($params: CreateAdaptiveExamMadeEasy) {
    createAdaptiveExamMadeEasy(params: $params) {
      jobId
      status
      total
    }
  }
`;

const CREATE_REMEDIAL_EXAM = gql`
  mutation CreateRemidialExam($params: CreateRemidialExamMadeEasy) {
    createRemidialExamMadeEasy(params: $params) {
      exam_paper_id
      filename
      exam_questions {
        id
        question
        subject
        chapter_name
      }
    }
  }
`;

const FETCH_STUDENTS = gql`
  query($institution_id: Int!) {
    getStudents(institution_id: $institution_id) {
      id
      student_name
      contact_no
      branch_id
      class_id
      section_id
      exam_id
      is_non_academic_exist
      is_academic_exist
    }
  }
`;


const FETCH_ADAPTIVE_EXAMSCHEDULESUBTYPES = gql` 
query($institution_id: Int!,$type: String) {
    getExamScheduleSubTypeQuestions(institution_id: $institution_id,type: $type){
        schedule_type_id
        schedule_sub_type_id
        schedule_sub_type
        adaptive_type_id
    }
}

`;



class AdaptiveExams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: Cookies.get("toggle") || "wrapper",
      showSubjectWise: true,
      showChapterWise: false,
      showStudenWise: false,
      subject_id: null,
      subject_name: null,
      range: null,
      chapters: [],
      students: [],
      isChaptersLoading: false,
      isStudentsLoading: false,
    };
  }


  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    const next =
      toggled === "wrapper"
        ? "wrapper sidebar-enable"
        : "wrapper";

    this.setState({ toggled: next });
    Cookies.set("toggle", next);
  };

  handleTabChange = (key) => {
    const type = key === "adaptive_exams" ? "adaptive" : "remedial";
    if (this.props.getExams && this.props.getExams.refetch) {
      this.props.getExams.refetch({
        institution_id: parseInt(Cookies.get("institutionid")),
        type,
        exam_paper_id: 0
      });
    }
  };

  handleSubjectClick = async (row) => {
    this.setState({
      showChapterWise: true,
      showStudenWise: false,
      subject_id: row.subject_id,
      subject_name: row.subject,
      range: row.range,
      isChaptersLoading: true
    });

    // try {
    //   const result = await this.props.client.query({
    //     query: FETCH_COLLEG_CHAPTERS,
    //     variables: {
    //       institution_id: parseInt(Cookies.get("institutionid")),
    //       subject_id: row.subject_id,
    //       range: 0
    //     },
    //     fetchPolicy: "network-only"
    //   });

    //   if (result.data && result.data.getAdaptiveSubjectChapters) {
    //     this.setState({
    //       chapters: result.data.getAdaptiveSubjectChapters,
    //       isChaptersLoading: false
    //     });
    //   } else {
    //     this.setState({ isChaptersLoading: false });
    //   }
    // } catch (error) {
    //   console.error("Error fetching chapters:", error);
    //   this.setState({ isChaptersLoading: false });
    // }
  }

  handleChapterClick = async (row) => {
    this.setState({
      showStudenWise: true,
      chapter_id: row.chapter_id,
      chapter_name: row.chapter_name,
      isStudentsLoading: true
    });

    // try {
    //   const result = await this.props.client.query({
    //     query: GET_CHAPTER_WISE_STUDENTS,
    //     variables: {
    //       institution_id: parseInt(Cookies.get("institutionid")),
    //       subject_id: this.state.subject_id,
    //       chapter_id: row.chapter_id,
    //       range: 0
    //     },
    //     fetchPolicy: "network-only"
    //   });

    //   if (result.data && result.data.getAdaptiveChapterStudents) {
    //     this.setState({
    //       students: result.data.getAdaptiveChapterStudents,
    //       isStudentsLoading: false
    //     });
    //   } else {
    //     this.setState({ isStudentsLoading: false });
    //   }
    // } catch (error) {
    //   console.error("Error fetching students:", error);
    //   this.setState({ isStudentsLoading: false });
    // }
  }

  columnStudentWise = [
    { dataField: "mobile", text: "Mobile", sort: true },
    { dataField: "score", text: "Score", sort: true },
    { dataField: "accuracy", text: "Accuracy", sort: true },
  ]

  subjectWiseColumns = [
    { dataField: "id", text: "ID", sort: true },

    {
      dataField: "subject",
      text: "Subject",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span
            style={{ color: "#007bff", cursor: "pointer", fontWeight: 500 }}
            onClick={() => this.handleSubjectClick(row)}
          >
            {cell}
          </span>
        );
      }
    },

    { dataField: "count", text: "Count", sort: true },
  ]

  chapterWiseColumns = [
    { dataField: "chapter_id", text: "ID", sort: true },

    {
      dataField: "chapter_name",
      text: "Chapter",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span
            style={{ color: "#007bff", cursor: "pointer", fontWeight: 500 }}
            onClick={() => this.handleChapterClick(row)}
          >
            {cell}
          </span>
        );
      }
    },

    { dataField: "count", text: "Count", sort: true },
  ]

  render() {
    if (!Cookies.get("token")) {
      this.props.history.push("/login");
      return null;
    }



    const { globals,
      //  getExams, 
      getStudents, getExamScheduleSubTypeQuestions } = this.props;
    const isInitialLoading = globals.loading || (getStudents && getStudents.loading);

    if (isInitialLoading) {
      return <PreloaderTwo />;
    }
    console.log(this.state.chapters)
    if (globals.error) {
      alert("Server Error. " + globals.error.message);
      return null;
    }

    let globalsData = { ...globals.globals };

    if (
      Cookies.get("userlevel") !== "1" &&
      Cookies.get("userlevel") !== "2"
    ) {
      globalsData.globalBranches = globalsData.globalBranches.filter(
        (item) => item.id === parseInt(Cookies.get("branch_id"))
      );
    }

    // const formattedData = getInstituteAdaptiveReport.getInstituteAdaptiveReport.flatMap((item, index) =>
    //   item.subjects.map(sub => ({
    //     id: index + 1,
    //     subject_id: sub.subject_id,
    //     range: item.range,
    //     subject: sub.subject,
    //     count: sub.count
    //   }))
    // );
    return (
      <div className={this.state.toggled}>


        <div
          className="content-wrapper mb-2"
          style={{ minHeight: "80vh", zIndex: 100 }}
        >
          <CreateAdaptiveExams
            type={this.props.type}
            globals={globalsData}
            // manageQuestions={this.props.getExams.getAdaptiveQuestions}
            // manageQuestionsForDropdown={this.props.getExams.manageQuestions}
            handleDelete={this.props.handleDelete}
            handleCreate={this.props.handleCreate}
            handleRemedialCreate={this.props.handleRemedialCreate}
            students={this.props.getStudents.getStudents}
            onTabChange={this.handleTabChange}
            // isExamsLoading={this.props.getExams.loading}
            getExamScheduleSubTypeQuestions={getExamScheduleSubTypeQuestions.getExamScheduleSubTypeQuestions}
          />
        </div>
        <Row>
          {/* <Col md={12}>
            <Card>
              <Card.Body>


                <DataTableWithOutSearch
                  parentData={formattedData}
                  particlecolumns={this.subjectWiseColumns}
                  // tableHeading={{ Title: `Manage ${type}` }}
                  name={`Subject Wise Data`}

                />
              </Card.Body>
            </Card>
          </Col> */}
          {this.state.showChapterWise && (
            this.state.isChaptersLoading ? (
              <PreloaderTwo />
            ) : (
              <Col md={12}>
                <Card>
                  <Card.Body>
                    <DataTableWithOutSearch
                      parentData={this.state.chapters}
                      particlecolumns={this.chapterWiseColumns}
                      // tableHeading={{ Title: `Manage ${type}` }}
                      name={`Chapter Wise Data`}

                    />
                  </Card.Body>
                </Card>
              </Col>
            )
          )}
          {this.state.showStudenWise && (
            this.state.isStudentsLoading ? (
              <PreloaderTwo />
            ) : (
              <Col md={12}>
                <Card>
                  <Card.Body>
                    <DataTableWithOutSearch
                      parentData={this.state.students}
                      particlecolumns={this.columnStudentWise}
                      // tableHeading={{ Title: `Manage ${type}` }}
                      name={`Student Wise Data`}

                    />
                  </Card.Body>
                </Card>
              </Col>
            )
          )}
        </Row>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withApollo,

  graphql(FETCH_GLOBALS, {
    options: () => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid")),
      },
    }),
    name: "globals",
  }),

  // graphql(FETCH_EXAMS, {
  //   options: () => ({
  //     variables: {
  //       institution_id: parseInt(Cookies.get("institutionid")),
  //       type: "adaptive",
  //       exam_paper_id: 0,
  //     },
  //     fetchPolicy: "network-only",
  //     notifyOnNetworkStatusChange: true,
  //   }),
  //   name: "getExams",
  // }),

  graphql(FETCH_STUDENTS, {
    options: () => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid"))
      }
    }),
    name: "getStudents",
  }),

  graphql(DELETE_EXAM, {
    props: ({ mutate }) => ({
      handleDelete: mutate,
    }),
  }),
  graphql(CREATE_ADAPTIVE_EXAM, {
    props: ({ mutate }) => ({
      handleCreate: mutate,
    }),
  }),
  graphql(CREATE_REMEDIAL_EXAM, {
    props: ({ mutate }) => ({
      handleRemedialCreate: mutate,
    }),
  }),
  graphql(FETCH_ADAPTIVE_EXAMSCHEDULESUBTYPES,
    {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
          type: "Adaptive_Exam"

        }
      }), name: "getExamScheduleSubTypeQuestions"
    }),


)(AdaptiveExams); 
